import React from "react";
import axios from "../../utils/Axios/axiosProxy";
import { menuItemsAdmin } from "../../utils/Data/dataTexts";
import AdminOrders from "./AdminOrders/AdminOrders";
import AdminUsers from "./AdminUsers/AdminUsers";
import DashboardMenu from "../UserDashboard/DashboardMenu/DashboardMenu";
import "./AdminDashboard.scss";
import AdminMessages from "./AdminMessages/AdminMessages";

export const AdminDashboardContext = React.createContext({});
export class AdminDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: "Orders",
      ordersFetched: false,
      userAccountsFetched: false,
      orders: [],
      userAccounts: [],
      messages: [],
      messagesFetched: false,
    };
  }
  componentDidMount() {
    const jwtFromLStorage = localStorage.getItem("JWT");
    this.getOrdersFromDB(jwtFromLStorage);
    this.getUserAccountsFromDB(jwtFromLStorage);
    this.getMessagesFromDB(jwtFromLStorage);
  }

  handleNavigation = (step) => {
    if (step !== this.state.activeStep) {
      this.setState({ activeStep: step });
    }
  };
  displayContent = (step) => {
    switch (step) {
      case "Orders":
        return (
          <div className="AdminDashboardContent">
            <AdminOrders
              orders={this.state.orders}
              ordersFetched={this.state.ordersFetched}
              getOrdersFromDB={this.getOrdersFromDB}
              manageOrder
            />
          </div>
        );
      case "Customers":
        return (
          <AdminUsers
            userAccounts={this.state.userAccounts}
            userAccountsFetched={this.state.userAccountsFetched}
          />
        );
      case "Support":
        return (
          <div className="AdminDashboardContent">
            <AdminMessages />
          </div>
        );
      default:
        return <></>;
    }
  };
  getOrdersFromDB = (JWT) => {
    axios
      .get("/api/order", {
        headers: {
          Authorization: `Bearer ${JWT}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("GET ORDERS RESPONSE: ", response.statusText);
        this.setState({
          orders: response.data.orders,
          ordersFetched: true,
        });
      })
      .catch((error) => {
        console.log("GET ORDERS ERROR: ", error);
      })
      .catch((error) => console.log("GET ORDERS FROM DB CLIENT ERROR", error));
  };
  getUserAccountsFromDB = (JWT) => {
    axios
      .get("/api/account", {
        headers: {
          Authorization: `Bearer ${JWT}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("GET ACCOUNTS RESPONSE: ", response.statusText);
        this.setState({
          userAccounts: response.data.accounts,
          userAccountsFetched: true,
        });
      })
      .catch((error) => {
        console.log("GET ACCOUNTS ERROR: ", error);
      })
      .catch((error) =>
        console.log("GET ACCOUNTS FROM DB CLIENT ERROR", error)
      );
  };
  getMessagesFromDB = (JWT) => {
    axios
      .get("/api/communication", {
        headers: {
          Authorization: `Bearer ${JWT}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("GET MESSAGES RESPONSE: ", response.statusText);
        this.setState({
          messages: response.data.messages,
          messagesFetched: true,
        });
      })
      .catch((error) => {
        console.log("GET MESSAGES ERROR: ", error);
      })
      .catch((error) =>
        console.log("GET MESSAGES FROM DB CLIENT ERROR", error)
      );
  };

  render() {
    return (
      <AdminDashboardContext.Provider value={this}>
        <div className="DashboardContainer">
          <div className="DashboardMenuContainer">
            <DashboardMenu
              handleNavigation={this.handleNavigation}
              activeStep={this.state.activeStep}
              menuItems={menuItemsAdmin}
            />
          </div>
          <div className="DasboardContentContainer">
            {this.displayContent(this.state.activeStep)}
          </div>
        </div>
      </AdminDashboardContext.Provider>
    );
  }
}
